import * as React from 'react';
import { Provider } from 'react-redux';
import { ErrorLogComponent } from '@cian/error-log-component';
import { uaToDeviceType } from '@cian/ui-kit/utils';
import { Provider as MicrofrontendProvider } from '@cian/mf-react';
import { NewbuildingCallbackWidgetProvider } from '../NewbuildingCallbackWidgetProvider';
import { TReduxStore } from '../../types/redux';
import { IApplicationContext } from '../../types/applicationContext';
import { ApplicationContext } from '../../utils';
import { AdfoxPixelContainer } from '../AdfoxPixel';
import { PageContainer } from '../Page';
import { UiKitRoot } from '@cian/ui-kit';
import { HydrationMarker } from './internal/components/HydrationMarker';

export interface IApplicationProps {
  applicationContext: IApplicationContext;
  reduxStore: TReduxStore;
  /**
   * Заглушка корневого error boundary. В браузере это снимок SSR-разметки,
   * чтобы при ошибке после гидрации контент не стирался; на сервере не передаётся.
   */
  errorStub?: React.ReactElement;
}

export function Application(props: IApplicationProps) {
  const { reduxStore, applicationContext, errorStub } = props;
  const { logger, microfrontendsRegistry, custom } = applicationContext;

  return (
    <ErrorLogComponent logger={logger} errorStub={errorStub}>
      <ApplicationContext.Provider value={applicationContext}>
        <UiKitRoot deviceType={uaToDeviceType(custom.userAgent)}>
          <Provider store={reduxStore}>
            <HydrationMarker />
            <MicrofrontendProvider registry={microfrontendsRegistry}>
              <NewbuildingCallbackWidgetProvider>
                <PageContainer />
                <AdfoxPixelContainer />
              </NewbuildingCallbackWidgetProvider>
            </MicrofrontendProvider>
          </Provider>
        </UiKitRoot>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
}
